import setFunctionName from 'utils/setFunctionName';

const promises = [];

/** to be used on the server */
export function rewindPromises() {
  return promises.splice(0, promises.length);
}

function asyncWrap(fn) {
  const newFn = function (...args) {
    const value = fn.apply(this, args);
    if (value && value.then) {
      promises.push(value);
    }
    return value;
  };

  setFunctionName(newFn, `async${fn.name || '<fn>'}`);

  return newFn;
}

/** decorator/wrapper */
export function async(target, key, descriptor) {
  if (descriptor && typeof descriptor.value === 'function') {
    descriptor.value = asyncWrap(descriptor.value);
  } else if (typeof target === 'function') {
    return asyncWrap(target);
  } else {
    throw new Error('@async called with invalid arguments');
  }
}



// WEBPACK FOOTER //
// ./spa/server-wait.jsx